import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {allCountries as legacyAllCountries} from "@vesta/vos-types/modules/platformLevel/geography/domain/CountryData";
import {z as zod} from "zod";

export {CountryId} from "@vesta/vos-types/modules/platformLevel/geography/domain/CountryData";

export type Country = {
    countryCode: string;
    currencyCode: string;
    dialingCode: string;
    flag: string;
    id: Uuid;
    name: string;
    referenceExchangeRateAgainstUsd: number;
};

export const countryValidator: zod.ZodType<Country> = zod.strictObject({
    countryCode: zod.string(),
    currencyCode: zod.string(),
    dialingCode: zod.string(),
    flag: zod.string(),
    id: uuidZodValidator,
    name: zod.string(),
    referenceExchangeRateAgainstUsd: zod.number(),
});

export const allCountries: Array<Country> = legacyAllCountries as unknown as Array<Country>;
